import axios from "axios";
import { API_BASE } from "@/lib/api";

const publicClient = axios.create({ baseURL: API_BASE });
const unwrap = (p) => p.then((r) => r.data);

// Public waitlist capture (lander). Lives outside the admin API so the lander never imports it.
export const waitlistApi = {
  join: (payload) => unwrap(publicClient.post("/waitlist", payload)),
  count: () => unwrap(publicClient.get("/waitlist/count")),
  status: (email) => unwrap(publicClient.get("/waitlist/status", { params: { email } })),
};
